import { render, staticRenderFns } from "./WebPhoneContacts.vue?vue&type=template&id=7805a736&scoped=true"
import script from "./WebPhoneContacts.vue?vue&type=script&lang=js"
export * from "./WebPhoneContacts.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneContacts.vue?vue&type=style&index=0&id=7805a736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7805a736",
  null
  
)

export default component.exports